import CrDetailPage from "@/features/change-requests/cr-detail.page";
import { isProjectFeatureEnabled } from "@/features/projects/utils/project-features";
import { projectHomeRedirect } from "@/features/projects/utils/project-home-destination";
import { IncognitoCrDetailPage } from "@/features/superuser/incognito/project/incognito-cr-detail.page";
import { useWorkspaceAccess } from "@/features/workspaces/use-workspace-access";
import { ProjectRoute } from "@/routes/_authenticated/workspaces/$slug/projects/$projectSlug";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/workspaces/$slug/projects/$projectSlug/cr/$crId",
)({
  beforeLoad: ({ context, params }) => {
    if (!isProjectFeatureEnabled(context.project, "show_change_requests")) {
      // CR-165: keeps ?incognito=support and lands on an allowlisted page.
      throw projectHomeRedirect(context.project, params, context.workspaceAccess);
    }
  },
  component: CrDetailPageRoute,
});

// CR-165: incognito mode gets the read-only CR page (no rename, no status or
// priority change, no archive, no description editor, no create / upload, no
// realtime subscription); the member page is untouched.
function CrDetailPageRoute() {
  const workspaceAccess = useWorkspaceAccess();
  const { project } = ProjectRoute.useRouteContext();
  const { slug, projectSlug, crId } = Route.useParams();

  if (workspaceAccess.mode === "incognito") {
    return (
      <IncognitoCrDetailPage
        key={crId}
        project={project}
        crId={crId}
        slug={slug}
        projectSlug={projectSlug}
      />
    );
  }

  return <CrDetailPage />;
}
